/**
 * Navigation class definition for webPOS.  Used to interface with Stencil.
 *
 * Copyright 2014 LightSpeed Retail. All rights reserved.
 * Created by kurtbergeron on 14-12-12.
 */

$(() => {
  function Navigation() {
    window.StencilWebAPI.NavigationBase.call(this);
  }
  Navigation.prototype = Object.create(window.StencilWebAPI.NavigationBase.prototype);
  Navigation.prototype.constructor = Navigation;

  /**
   * Updates the navigation state using the StencilAPI with the current state of
   * of the navigation components in webPOS.
   */
  Navigation.prototype.updateNavState = function() {
    this.updateNavigationElements();

    this.updateTitleState();
    this.updateBreadcrumbState();
    this.updatePageControlState();

    window.StencilWebAPI.NavigationBase.prototype.updateNavState.call(this);
  };

  /**
   * Updates the private $element properties that contain the current navigation
   * state of the app.
   */
  Navigation.prototype.updateNavigationElements = function() {
    this._$header = $('.cr-topbar');

    // Record navigation we don't want to show can be in the DOM in a hidden view
    // panel.  If the view pannel is visible then we want to pass the record
    // pagination state to stencil.
    this._$pageControls = $('#view')
      .filter(':visible')
      .find('.records');
  };

  /**
   * Sets the current page title title with the StencilAPI
   */
  Navigation.prototype.updateTitleState = function() {
    var $title = this._$header.find('.js-page-title');
    this.setTitle($title.length ? $title.text().trim() : '');
  };

  /**
   * Sets the current page's breadcrumbs with the StencilAPI
   */
  Navigation.prototype.updateBreadcrumbState = function() {
    var $breadcrumbs = this._$header.find('.js-breadcrumb a');
    var breadcrumbs = [];

    if ($breadcrumbs.length) {
      $breadcrumbs.each(function(index, crumb) {
        var $crumb = $(crumb);

        breadcrumbs.push(
          new window.StencilWebAPI.Breadcrumb(
            $crumb
              .text()
              .trim()
              .replace(/\s+/g, ' '),
            '',
            $crumb
          )
        );
      });
    }

    this.setBreadcrumbs(breadcrumbs);
  };

  /**
   * Sets the current page controls with the StencilAPI
   */
  Navigation.prototype.updatePageControlState = function() {
    var pageControls = new window.StencilWebAPI.PageControls();

    if (this._$pageControls.length) {
      pageControls.recordNum = parseInt(this._$pageControls.find('.current-record').text());
      pageControls.lastRecord = parseInt(this._$pageControls.find('.last-record').text());
      pageControls.$prev = this._$pageControls.find('.previous-button');
      pageControls.$next = this._$pageControls.find('.next-button');
    }

    this.setPageControls(pageControls);
  };

  /**
   * Called by stencil.  Invokes the webPOS function to jump to the provided record
   * number.
   *
   * @param index {integer}  The integer of the record number to jump to.  Note that
   *                         record number does not equal record id.
   **/
  Navigation.prototype.moveToRecord = function(index) {
    var viewID = this._$pageControls.find('.direct').data('view-id');
    if (viewID) {
      window.gotoRecordNumber(viewID, parseInt(index));
    }
  };

  /**
   * Called by stencil. Invokes webPOS functionality to navigate to the url
   *
   * @param data {object} An object containing a string "url"
   **/
  Navigation.prototype.navigateToURL = function(data) {
    if (!data || !data.url) {
      throw new Error('Improperly formatted parameter');
    }

    const params = window.merchantos.utils.getQueryParams(data.url);

    switch (params.form_name) {
      case 'ui_tab':
        window.merchantos.tabs.show(params.tab);
        break;
      case 'listing':
        window.OpenListing('listing', params.name, false, params.tab);
        break;
      case 'view':
        window.newView('view', params.name, params.id, params.tab);
        break;
      default:
        window.merchantos.utils.openUrl(data.url);
    }
  };

  /**
   * Called by Stencil.  Determines if the current view has unsaved changes.
   *
   * @returns {Boolean} True if there are unsaved changes in the view.
   */
  Navigation.prototype.hasUnsavedChanges = function() {
    return window.hasUnsavedChanges();
  };

  Navigation.prototype.doSave = function() {
    return window.saveChanges();
  };
  window.Navigation = Navigation;
});
